<template>
  <div id="app">
    <!--Aqui irá o sitemap-->
    <component v-bind:is="layout"></component>

    <BuscarRota ref="search"></BuscarRota>

    <notifications group="notifications-default" />

    <core-mensagem :tipo="msg.tipo" :titulo="msg.titulo" :mensagem="msg.mensagem" :ok="msg.ok"
      :show="msg.show"></core-mensagem>

    <core-confirmacao :titulo="conf.titulo" :mensagem="conf.mensagem" :sim="conf.sim" :nao="conf.nao"
      :show="conf.show"></core-confirmacao>

    <BlockUI message :html="htmlLoading" v-if="loading" />
  </div>
</template>

<style src="./style.scss" lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
// layout em branco da página index
import IndexLayout from "./_layouts/LayoutBlank";

// layout do sistema
import AppLayout from "./_layouts/Layout1";
import gridButtom from "./components/core/GridButtom.vue";
import gridCheckbox from "./components/core/GridCheckbox.vue";
import situacaoCirculo from "./components/core/SituacaoCirculo.vue";

export default {
  components: {
    BuscarRota: () => import("./views/BuscarRota"),
  },
  metaInfo: {
    title: `${process.env.VUE_APP_BANCO} - Money Plus`,
    titleTemplate: "%s - SPB",
  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove("app-loading"), 1);
  },
  name: "App",
  data() {
    return {
      htmlLoading: `<div class="sk-folding-cube sk-primary">
                    <div class="sk-cube1 sk-cube"></div>
                    <div class="sk-cube2 sk-cube"></div>
                    <div class="sk-cube4 sk-cube"></div>
                    <div class="sk-cube3 sk-cube"></div>
                  </div>
                  <h5 class="text-center mb-0">Carregando...</h5>`,
      contadorOperadorAusente: process.env.VUE_APP_MOUSE_IDLE_SESSION_TIME,
      contadorOperadorAusenteRodando: false,
      statusAcessoOperador: "loggedOut",
      mouseXOldValue: null,
      mouseYOldValue: null
    };
  },
  mounted() {
    var vm = this;
    vm.statusAcessoOperador = localStorage.getItem("status")

    vm.$store.commit("isMobile");
    window.addEventListener("resize", function () {
      vm.$store.commit("isMobile");
    });

    vm.$store.commit("gridButtom", gridButtom);
    vm.$store.commit("gridCheckbox", gridCheckbox);
    vm.$store.commit("situacaoCirculo", situacaoCirculo);

    document.addEventListener("mousemove", function (event) {

      if (vm.statusAcessoOperador == "loggedIn") {
        if (event.movementX != vm.mouseXOldValue || event.movementY != vm.mouseYOldValue) {
          vm.contadorOperadorAusente = process.env.VUE_APP_MOUSE_IDLE_SESSION_TIME;
          vm.mouseXOldValue = event.movementX;
          vm.mouseYOldValue = event.movementY;
          if (!vm.contadorOperadorAusenteRodando) {
            vm.statusAcessoOperador = localStorage.getItem("status")
          }
        }
      }
    });

    document.addEventListener("keydown", function (event) {
      // CTRL + L combo
      if (localStorage.getItem("user") !== null)
        if (event.ctrlKey && event.code == "Space")
          vm.$refs.search.show = vm.$refs.search.show ? false : true;
    });

    window.addEventListener("statusAcessoOperador-changed", function (event) {
      vm.statusAcessoOperador = event.detail.storage
    })
  },
  methods: {
    contarTempoParado() {
      var vm = this;
      if (vm.contadorOperadorAusente > 0 && vm.statusAcessoOperador == 'loggedIn') {
        window.setTimeout(function () {
          vm.contadorOperadorAusente--
          vm.contarTempoParado()
        }, 1000)
        vm.contadorOperadorAusenteRodando = true
      } else {
        vm.contadorOperadorAusenteRodando = false
        this.$store.dispatch('logout')
      }
    }
  },
  watch: {
    statusAcessoOperador(val) {
      if (val == "loggedIn") {
        this.contarTempoParado()
      }
    }
  },
  computed: {
    msg() {
      return this.$store.getters.mensagem;
    },
    conf() {
      return this.$store.getters.confirmacao;
    },
    loading() {
      if (this.$route.name === 'Dashboard') 
        return false

      return this.$store.getters.loading || this.$store.getters.activeRequests > 0
    },
    layout() {
      this.$store.commit("SET_LAYOUT", IndexLayout);

      // verifica se não é a tela de login, se for, mantém o layout em branco
      if (["/", "/lembrar", "/recuperar", "/registrarmfafisico"].indexOf(this.$route.path) < 0) {
        this.$store.commit("SET_LAYOUT", AppLayout);
      }
      return this.$store.getters.layout;
    },
  }
};
</script>